import { api } from './client';

export const athletesAPI = {
  acknowledgeVolumeWarning: (acknowledged) => api.patch('/athletes/me/acknowledge-volume-warning/', { acknowledged }),
  list: (params) => api.get('/athletes/', { params }),
  getTelegramLinkToken: () => api.post('/athletes/telegram-link-token/'),
  changePassword: (currentPassword, newPassword) =>
    api.post('/athletes/me/change-password/', { current_password: currentPassword, new_password: newPassword }),
  get: (id) => api.get(`/athletes/${id}/`),
  me: () => api.get('/athletes/me/'),
  update: (id, data) => api.patch(`/athletes/${id}/`, data),
  updateMe: (data) => api.patch('/athletes/me/update/', data),
  delete: (id) => api.delete(`/athletes/${id}/`),
  stats: (id) => api.get(`/athletes/${id}/stats/`),
  vdotHistory: (id) => api.get(`/athletes/${id}/vdot-history/`),
  adminList: () => api.get('/athletes/admin/list/'),
  adminUpdate: (id, data) => api.patch(`/athletes/${id}/admin/update/`, data),
  toggleAccess: (id) => api.patch(`/athletes/${id}/admin/toggle-access/`),
  setAccess: (id, days) => api.patch(`/athletes/${id}/admin/set-access/`, { days }),
  addWeight: (id, weight) => api.post(`/athletes/${id}/add-weight/`, { weight }),
  disconnectTelegram: () => api.post('/athletes/telegram-disconnect/'),
  addHrMaxObservation: (id, observed_max_hr) => api.post(`/athletes/${id}/add-hr-max-observation/`, { observed_max_hr }),
  addHrMaxEstimate: (id, race_distance_m, hr_avg_last_1km) =>
    api.post(`/athletes/${id}/add-hr-max-estimate/`, { race_distance_m, hr_avg_last_1km }),
};

export const shoesAPI = {
  list: () => api.get('/shoes/'),
  create: (data) => api.post('/shoes/', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, data) => api.patch(`/shoes/${id}/`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  remove: (id) => api.delete(`/shoes/${id}/`),
  history: (id) => api.get(`/shoes/${id}/history/`),
  addPhoto: (id, file) => {
  const fd = new FormData();
  fd.append('image', file);
  return api.post(`/shoes/${id}/photos/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    },
    setMainPhoto: (id, photoId) => api.patch(`/shoes/${id}/photos/${photoId}/`),
    removePhoto: (id, photoId) => api.delete(`/shoes/${id}/photos/${photoId}/`),


};